import * as types from "../Actions/ActionTypes";
import initialState from "./initailState";
import { clearAuthStorage } from "../../authSession";

const toStoredBearerToken = (token) => {
  if (!token) return "";
  return token.toLowerCase().startsWith("bearer ") ? token : `bearer ${token}`;
};

const app = (state = initialState.app, action) => {
  switch (action.type) {
    case types.LOGIN_API:
      return {
        ...state,
        // loading: true,
        authError: null,
      };

    case types.SET_LOGIN: {
      const loginData = action.data?.data || action.data;
      const storedToken = toStoredBearerToken(loginData?.token);

      if (storedToken) {
        localStorage.setItem("token", storedToken);
      }

      return {
        ...state,
        loading: false,
        success: true,
        loggedIn: true,
        userDetails: loginData,
        token: storedToken,
        sessionToken: loginData?.sessionToken || "",
        error: false,
        authError: null,
      };
    }

    case types.AUTH_LOGOUT:
      clearAuthStorage();
      return {
        ...state,
        loading: false,
        success: false,
        error: false,
        token: "",
        sessionToken: "",
        loggedIn: false,
        userDetails: false,
        authError: null,
        authRefreshing: false,
      };

    case types.AUTH_SET_ERROR:
      return {
        ...state,
        authError: action.payload,
      };

    case types.AUTH_CLEAR_ERROR:
      return {
        ...state,
        authError: null,
      };

    case types.SET_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        authError: action.data || action.payload || true,
      };

    case types.SET_LOUGOUT:
      clearAuthStorage();
      return {
        ...state,
        token: "",
        sessionToken: "",
        loggedIn: false,
        userDetails: false,
      };

    case types.SET_NAME_APPBAR:
      return { ...state, appBarName: action.data };

    case types.SET_LAYOUT_IN_APP:
      return { ...state, layout: action.data };

    case types.SET_CLIENT_THEME:
      return {
        ...state,
        appTheme: action.data.data,
        loading: false,
        mainAppLoading: false,
      };

    case types.CLIENT_THEME_CALL:
      return { ...state, loading: true, mainAppLoading: true };

    case types.CLIENT_THEME_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
        mainAppLoading: false,
      };

    case types.DEFAULT_THEME_CALL:
      return { ...state, loading: true, mainAppLoading: true };

    case types.DEFAULT_THEME_SUCCESS:
      return {
        ...state,
        defaultTheme: action.data,
        loading: false,
        mainAppLoading: false,
      };

    case types.DEFAULT_THEME_ERROR:
      return { ...state, error: true, loading: false };

    case types.CLIENT_PORTAL_CONFIG_CALL:
      return { ...state, loading: true };

    case types.CLIENT_PORTAL_CONFIG_SUCCESS:
      return { ...state, portalConfig: action.data, loading: false };

    case types.CLIENT_PORTAL_CONFIG_ERROR:
      return { ...state, error: true, loading: false };

    case types.USER_LEFT_MENU_CALL:
      return { ...state, loading: true };

    case types.USER_LEFT_MENU_SUCCESS:
      return { ...state, leftMenu: action.data, loading: false };

    case types.USER_LEFT_MENU_ERROR:
      return { ...state, error: true, loading: false };

    default:
      return state;
  }
};

export default app;
